import { IconButton, IconButtonProps } from "@mui/material";
// import CircularProgress from "@mui/material/CircularProgress";
import React from "react";

interface FdIconButtonProps extends IconButtonProps {
  disabled?: boolean;
  isLoading?: boolean;
  Icon?: React.ReactNode;
}

const FdIconButton = ({
  // variant = "contained",
  isLoading,
  children,
  Icon,
  ...others
}: FdIconButtonProps): JSX.Element => {
  return (
    <IconButton size="small" {...others}>
      {Icon}
    </IconButton>
  );
};

export default FdIconButton;
